import React from "react";

export const LazyEmailThreadPopupBridge = React.lazy(
    () =>
        import(/* webpackChunkName: "EmailThreadPopup" */ "./EmailThreadPopup")
);
